// Internal

import { ModalName } from '../services/bootstrap-modal/modal-values.service';
import { MODULE_PATHS } from '../services/language/language.service';

export interface ModalProperties {
    activated: boolean;
    modalActivated: ModalName | null;
    modalOpening: boolean;
    isAnimating: boolean;
};

export class ModalContainerOptions {
    // size?: ModalSize = ModalSize.MD;
    backdropDismissable?: boolean = true;
    buttonDismissable?: boolean = true;
    exceptionClass?: string;
    isFlow?: boolean = false;
    useShellFooter?: boolean = false;
    // reverseAnimation?: boolean = false;
};

export interface ModalContentOptions extends ModalContentOptionsError {
    scenario?: string,
    alreadyActive?: boolean,
    trial?: boolean,
    currentStep?: string,
    flow?: string;
    isOnboardingFlow?: boolean,
    skipRedirectAtClose?: boolean,
    type?: string,
    user?: any,
    project?: any,
    contact?: any,
    tenantId?: any,
    organisation?: any,
    contactId?: any,
    departmentId?: any,
    departmentName?: string,
    visitId?: any,
    visitName?: string,
    taskId?: any,
    taskName?: string,
    clientId?: any,
    contractId?: any,
    contractNo?: string,
    annexId?: any,
    annexName?: string
};

export interface ModalContentOptionsError {
    inviteId?: number,
    groupId?: number,
    groupName?: string,
    lookupType?: string,
    lookupId?: string,
    lookupName?: string,
    trialId?: number,
    meter?: any,
    equipmentId?: number,
    spaceId?: any,
    supplierId?: any
};

// export enum ModalSize {
//     /** width: 440px */
//     SM = 'sm',
//     /** width: 600px */
//     MD = 'md',
//     .....etc.....
//     AUTO = 'auto'
// };

export interface AllModalInformation {
    moduleName: MODULE_PATHS
    name: ModalName,
    title?: string,
    containerOptions: ModalContainerOptions,
    contentOptions?: any,
    options?: object,
    callback?: (data?: any) => void
};

export type ModalNamesToPaths = {
    [key in MODULE_PATHS]?: {
        [key in ModalName]?: () => Promise<object>
    }
}
